module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book-list-wrapper"
  }, [_c('div', {
    staticClass: "book-list-search"
  }, [_c('h3', [_vm._v("未排期区本")]), _c('el-input', {
    attrs: {
      "placeholder": "请输入区本号",
      "icon": "search"
    },
    model: {
      value: (_vm.searchBookVal),
      callback: function($$v) {
        _vm.searchBookVal = $$v
      },
      expression: "searchBookVal"
    }
  })], 1), _c('vddl-list', {
    staticClass: "book-list row",
    attrs: {
      "list": _vm.resultBookList,
      "drop": _vm.handleDrop
    }
  }, [_c('vddl-placeholder', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "book-item-box"
  }, [_vm._v("插入")])]), _vm._l((_vm.resultBookList), function(item, index) {
    return _c('vddl-draggable', {
      key: item.label,
      staticClass: "book-item col-sm-6",
      class: {
        'selected': _vm.selected === item
      },
      attrs: {
        "draggable": item,
        "index": index,
        "wrapper": _vm.resultBookList,
        "effect-allowed": "move",
        "selected": _vm.selectedEvent
      }
    }, [_c('div', {
      staticClass: "book-item-box"
    }, [_vm._v(_vm._s(item.label))])])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-408cc340","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/MeterReading/Schedule/BookList.vue
// module id = 1743
// module chunks = 1